/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAmountVo } from './ServiceAmountVo';
import {
    ServiceAmountVoFromJSON,
    ServiceAmountVoFromJSONTyped,
    ServiceAmountVoToJSON,
    ServiceAmountVoToJSONTyped,
} from './ServiceAmountVo';

/**
 * 
 * @export
 * @interface OrderItemVo
 */
export interface OrderItemVo {
    /**
     * 订单id
     * @type {number}
     * @memberof OrderItemVo
     */
    orderId?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderItemVo
     */
    orderCode?: string;
    /**
     * 下单会员名
     * @type {string}
     * @memberof OrderItemVo
     */
    orderUserName?: string;
    /**
     * 出库日期
     * @type {string}
     * @memberof OrderItemVo
     */
    outboundDate?: string;
    /**
     * 各附加服务金额及分成明细
     * @type {Array<ServiceAmountVo>}
     * @memberof OrderItemVo
     */
    services?: Array<ServiceAmountVo>;
    /**
     * 小计（该订单附加服务金额合计）
     * @type {number}
     * @memberof OrderItemVo
     */
    subtotalAmount?: number;
    /**
     * 业绩（该订单分成金额合计）
     * @type {number}
     * @memberof OrderItemVo
     */
    commissionAmount?: number;
}

/**
 * Check if a given object implements the OrderItemVo interface.
 */
export function instanceOfOrderItemVo(value: object): value is OrderItemVo {
    return true;
}

export function OrderItemVoFromJSON(json: any): OrderItemVo {
    return OrderItemVoFromJSONTyped(json, false);
}

export function OrderItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderUserName': json['orderUserName'] == null ? undefined : json['orderUserName'],
        'outboundDate': json['outboundDate'] == null ? undefined : json['outboundDate'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(ServiceAmountVoFromJSON)),
        'subtotalAmount': json['subtotalAmount'] == null ? undefined : json['subtotalAmount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
    };
}

export function OrderItemVoToJSON(json: any): OrderItemVo {
    return OrderItemVoToJSONTyped(json, false);
}

export function OrderItemVoToJSONTyped(value?: OrderItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'orderUserName': value['orderUserName'],
        'outboundDate': value['outboundDate'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(ServiceAmountVoToJSON)),
        'subtotalAmount': value['subtotalAmount'],
        'commissionAmount': value['commissionAmount'],
    };
}

